module.exports = __webpack_public_path__ + "img/WhatsAppButtonGreenLarge.f92d7170.svg";